import { GeofenceCategory } from '@cobliteam/common-types';
import Tag from '@cobliteam/ui/components/Tag';

import Icon, { type IconNames } from '@cobliteam/ui/icons';
import type React from 'react';

interface GeofenceBadgeProps {
  category: GeofenceCategory | 'default';
}

type TagColors = React.ComponentProps<typeof Tag>['color'];
type BadgeStyles = Record<
  string,
  {
    color: TagColors;
    label: string;
    icon: IconNames;
  }
>;

const badgeStyles: BadgeStyles = {
  [GeofenceCategory.BASE]: {
    color: 'primary',
    label: 'Base',
    icon: 'cb-geofences-home',
  },
  [GeofenceCategory.CLIENT]: {
    color: 'success',
    label: 'Cliente',
    icon: 'user-round',
  },
  [GeofenceCategory.OTHER]: {
    color: 'warning',
    label: 'Outro',
    icon: 'map-pin',
  },
  [GeofenceCategory.MAINTENANCE]: {
    color: 'danger',
    label: 'Manutenção',
    icon: 'cb-maintenance',
  },
  [GeofenceCategory.SUPPLY]: {
    color: 'purple',
    label: 'Abastecimento',
    icon: 'fuel',
  },
  [GeofenceCategory.HEADQUARTER]: {
    color: 'sky',
    label: 'Sede',
    icon: 'house',
  },
  default: { color: 'default', label: 'Tipo não cadastrado', icon: 'map-pin' },
};

const GeofenceBadge = ({ category }: GeofenceBadgeProps) => {
  const { color, label, icon } = badgeStyles[category] || badgeStyles.default;
  return <Tag variant='surface' label={label} icon={<Icon name={icon} />} color={color} />;
};

export default GeofenceBadge;
